<ng-container *transloco="let t; read: 'common'">
    <footer class="navbar navbar-expand-lg" style="position: relative; bottom: 0; width: 100%;">        
            <div class="container d-flex flex-column flex-md-row justify-content-md-between justify-content-center">
                <div *ngIf="socialSettings" class="social-links">
                    <a *ngIf="socialSettings['social_instagram']" href="{{socialSettings['social_instagram']}}" class="fa fa-instagram social"></a>
                    <a *ngIf="socialSettings['social_facebook']" href="{{socialSettings['social_facebook']}}" class="fa fa-facebook social"></a>
                    <a *ngIf="socialSettings['social_youtube']" href="{{socialSettings['social_youtube']}}" class="fa fa-youtube social"></a>
                    <a *ngIf="socialSettings['social_twitter']" href="{{socialSettings['social_twitter']}}" class="fa fa-twitter social"></a>
                </div>
                <div class="text-center">
                    <!-- <span>Calímaco {{config['main_name']}} - 2024</span> -->
                    <span>{{config['main_name']}} - 2024</span>
                </div>
                <div class="language-links">
                    <a (click)="changeLang('eng')" *ngIf="currentLanguage !== 'eng'" [routerLink]=""  style="margin-right: 1.5rem;">English</a>
                    <a (click)="changeLang('spa')" *ngIf="currentLanguage !== 'spa'" [routerLink]="" style="margin-right: 1.5rem;">Español</a>
                    <a (click)="changeLang('ara')" *ngIf="currentLanguage !== 'ara'" [routerLink]="">العربية</a>
                </div>
            </div>
    </footer>

</ng-container>
  
    

    
    
    